import moment from "moment";
import * as R from "ramda";

export const calculateDuration = (start, end) => {
  const years = end.diff(start, "years");
  const months = R.when(months => months === 0 && years === 0, () => 1)(
    end.diff(start, "months") % 12
  );

  const yearsText = years ? `${years} año${years > 1 ? "s" : ""}` : "";
  const monthsText = months ? `${months} mes${months > 1 ? "es" : ""}` : "";

  return `${yearsText}${yearsText && monthsText ? " y " : ""}${monthsText}`;
};

export const isRecent = applyTime => {
  const RECENT_POSTULATION_DAYS = 2;
  return (
    moment.duration(moment().diff(moment(applyTime))).asDays() <=
    RECENT_POSTULATION_DAYS
  );
};
